<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 2004 -</span>
        <h2>熱血新創</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/taiwan-startups/taiwan-startups-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/taiwan-startups/taiwan-startups.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/陳亭均</small></p>
      <p>2000年開始，跨境詐騙集團逐漸成形，台灣成為詐騙攻擊對象。詐欺背信案件從1996年的2,889件至2004年上升至40,144件，成長近13倍。</p>
      <p>政府成立「0800-018110反詐騙諮詢專線」，供民眾諮詢，並於隔年2005年4月，正式更名為「165反詐騙諮詢專線」，自此165成了反詐騙代號。</p>
      <p>而在2006年，詐騙件數及詐騙金額來到最高峰，單年詐騙金額逾180億元。同年11月，與金融機構配合啟動「警示帳戶聯防機制」，2007年警政單位與金融機構合作，共攔截被害金額達2.45億餘元。</p>
      <figure class="article-img">
        <img src="../../assets/images/taiwan-startups/pic-01.png" alt="">
        <figcaption>鄭勝丰、郭建甫、宋政桓成立Gogolook後，更不斷深化服務，向國際輸出台灣防詐經驗。</figcaption>
      </figure>
      <p>2013年，Gogolook共同創辦人郭建甫、宋政桓、鄭勝丰一手催生陌生來電辨識App「Whoscall」，因Google執行長史密特點名說讚而聲名大噪。但在2012年底，他們資金燒到探底，缺口上千萬元，連員工薪水都發不出來，直到資鼎創投投了第二輪資金、國發基金奧援，才暫解燃眉之急。</p>
      <p>準備與LINE母公司、韓國最大入口網站「NAVER」創辦人李海珍見面前，Gogolook共同創辦人郭建甫超級緊張。當介紹人告訴他：「五分鐘後碰面。」他立刻倒抽口涼氣，畢竟一切都來得迅雷不及掩耳，「我根本不可能為這一天做好準備。」</p>
      <p>緊張歸緊張，郭建甫心裡很明白自己到底在做什麼。「LINE把朋友、熟人圈圈做得很好，而我們做的是陌生人，如果能合作，可以做得更好。」</p>
      <p>接下來的故事就眾所周知，NAVER捧著新台幣5.29億元把Gogolook娶回家，這也是繼無名小站被雅虎併購後，另一個台灣新創風光大嫁的傳奇故事。</p>
      <p>然而大家或許不曉得，Gogolook故事並沒有因為嫁給韓國NAVER就寫下句號。三位創辦人不久之後下了個更大的決心，從2015年起，一點一滴、真金白銀地把創辦的公司又買回自己手中。「我們把自己錢全部都先掏出來了！」用這種魄力說服「母艦」NAVER賣回部分股票，讓創辦人主導公司持續創新。</p>
      <p>Gogolook財務顧問、寬量國際（QIC）執行長李鴻基也說，「這個公司就是要回歸『台灣隊』的公司。」接下來，他們不只想往IPO（首次公開募股）邁進，「他們想打造的是『來自台灣的國際級公司』。」</p>
      <figure class="article-img">
        <img src="../../assets/images/taiwan-startups/pic-02.png" alt="">
        <figcaption>警政署與LINE公司積極合作，成立165反詐騙LINE官方帳號。</figcaption>
      </figure>
      <p>而在2013年，防詐成效也開始顯現，詐騙案件自2009年逐年降低，2013年來到最低1萬8千多件。</p>
      <p>到了2014年8月，因應智慧型手機及平板電腦等通訊設備普及化，LINE詐騙案件及手機簡訊連結小額付費等方式盛行，警政署與LINE公司積極合作，成立165反詐騙line官方帳號。2016年7月，警政署165專線與Gogolook簽訂合作備忘錄，共享電話資料庫大數據，協助民眾防範電話詐騙。</p>
      <figure class="article-img">
        <img src="../../assets/images/taiwan-startups/pic-03.png" alt="">
        <figcaption>網路爆紅的闢謠機器人「美玉姨」，有效解決氾濫網路謠言。</figcaption>
      </figure>
      <p>自從Whoscall問世以來，郭建甫、鄭勝丰、宋政桓早跟詐騙集團纏鬥十餘年，累積了龐大的資料庫、文字探勘以及AI技術，郭建甫清楚，這些都是企業的「根」。</p>
      <p>台灣曾因詐騙猖獗「享譽全球」，然而這間從「防詐」開始的台灣公司，卻希望從台灣向世界輸出完整的「防詐網絡」方案。</p>
      <p>從成立第一天起，Whoscall就進軍「國際盃」，現在同樣沒有停下腳步。日積月累，目前在全球下載次數已突破八千萬，主要服務範圍涵蓋台灣、日本、韓國、香港、泰國、巴西、馬來西亞等地區。要真正築起防詐長城與企業市場，必須打造國際間的「區域聯防」系統。</p>
      <p>今年疫情期間，詐騙簡訊、電話數量大增，Whoscall提出「2.0共同防詐」合作概念，與中央流行疫情指揮中心、警政署合作，組成「防詐國家隊」。</p>
      <p>除此之外，Gogolook今年與LINE上的可疑訊息查證機器人「美玉姨」聯手。Whoscall解決詐騙簡訊和電話，美玉姨則進一步深入通訊軟體，讓Gogolook找到了典範轉移的可能性，防詐騙與假訊息防治更聯合成一道防線。抓緊「防詐」的核心競爭力，郭建甫力圖讓自己的「防詐網絡」擴及其他產業領域。</p>
      <p>而隨著日本步入台灣後塵，詐騙電話崛起，whoscall也正式進軍日本，在日本福岡設立第一間海外分公司。</p>
      <p>台灣資金也看見了這匹正在狂奔的駿馬，期待它頭上長出獨角。今年Gogolook公布新一輪投資人，連全球砷化鎵晶圓代工龍頭穩懋半導體，竟然也成為他們的夥伴。</p>
      <p>郭建甫說起與穩懋老董陳進財一拍即合的故事，當時李鴻基舉辦了一場「Power Dinner」，雖然邀請郭建甫上台分享創業故事，但壓根兒沒想到要替Gogolook募資。當郭建甫講完一路走來的心路歷程與未來藍圖時，沒想到台下的陳進財與另外兩位企業家，馬上詢問未來有沒有可以幫上忙的地方。</p>
      <figure class="article-img">
        <img src="../../assets/images/taiwan-startups/pic-04.png" alt="">
        <figcaption>2020年，Gogolook獲得「總統創新獎」。</figcaption>
      </figure>
      <p>而抓緊「防詐」的核心競爭力，Gogolook不久之前才與國泰世華商業銀行、凱基商業銀行、匯豐銀行、花旗銀行、渣打銀行、王道銀行等六間銀行，推出全新防詐信貸比較平台「貸鼠先生」。3月開始試營運以來，「貸鼠先生」成功核貸總金額已突破新台幣1億元。</p>
      <p>而對於今年剛從總統蔡英文手中接下「總統創新獎」，郭建甫欣慰地說，「2020年，有點像是很多總結過去的努力！」從獲獎到「防詐白皮書」，確實把他們「台灣第一防詐品牌」的招牌擦的亮晃晃地。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
